import { render } from "./UnderMaintenance.vue?vue&type=template&id=15599f38&scoped=true"
import script from "./UnderMaintenance.vue?vue&type=script&lang=js"
export * from "./UnderMaintenance.vue?vue&type=script&lang=js"

import "./UnderMaintenance.vue?vue&type=style&index=0&id=15599f38&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15599f38"]])

export default __exports__